import PropTypes from 'prop-types';
import * as Helper from './../utilities/helper';

export default function Employees({ pictures, jobCount }) {
	const getEmployees = () => {
		const imageData = JSON.parse(JSON.stringify(pictures));

		// Calculate how many images can be displayed at max
		const maxImageCount = Math.floor(jobCount / 4);

		if (maxImageCount > 0) {
			let imageCollection = [];
			const gender = ['female', 'divers', 'male'];

			for (let genderIndex = 0; imageCollection.length < maxImageCount; genderIndex++) {
				// Return if there are no items left
				if (!imageData[gender[0]].length && !imageData[gender[1]].length && !imageData[gender[2]].length) break;

				// Reset gender index to start from new again
				if (genderIndex === gender.length) genderIndex = 0;
				const genderTerm = gender[genderIndex];

				if (genderTerm in imageData && imageData[genderTerm].length) {
					const items = imageData[genderTerm];
					const rand = Math.floor(Math.random() * items.length);
					const randomImage = items[rand];

					// Add image to collection
					if (!imageCollection.includes(randomImage)) {
						imageCollection.push(randomImage);
						items.splice(rand, 1);
					}
				}
			}

			if (imageCollection.length) {
				// Shuffle array
				imageCollection = Helper.shuffleArray(imageCollection);

				return imageCollection.map((src, i) => {
					// Calculate ratio to determine vertical distance of images
					// * 100 % of total height divided by all items + 1 (to have an offset on top & bottom)
					const ratio = 100 / (imageCollection.length + 1);
					const styles = {
						top: (i + 1) * ratio + '%',
					};
					return (
						<div key={`employee-img-${i}`} className="jobs__empl-img" style={styles}>
							<img src={src} alt={`Employee ${i}`} />
						</div>
					);
				});
			}
		}
		return null;
	};

	return <div className="jobs__employee-pictures">{getEmployees()}</div>;
}

Employees.propTypes = {
	pictures: PropTypes.object.isRequired,
	jobCount: PropTypes.number.isRequired,
};
